export default "__VITE_ASSET__BQNfpQ$o__"